import { render, staticRenderFns } from "./manage-annulation.html?vue&type=template&id=5a985e78&scoped=true&external"
import script from "./manage-annulation.js?vue&type=script&lang=js&external"
export * from "./manage-annulation.js?vue&type=script&lang=js&external"
import style0 from "./manage-annulation.scss?vue&type=style&index=0&id=5a985e78&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a985e78",
  null
  
)

export default component.exports